import { Furniture } from '@spazious/dollhouse-graphql';
import { VirtualFurnitureAttributesAvailabilityStatusEnum } from '@spazious/react-backoffice';

import { RestApiClient } from '../context.js';

import { mapFurniture } from './mapFurniture.js';

export const getFurnitures = async (api: RestApiClient, spaceId: string): Promise<Furniture[]> =>
  (
    await api.diagramming.listDiagrammingVirtualFurnitures({
      filterVirtualMeetingRoom: spaceId,
      pageSize: 50,
      filterAvailabilityStatusIn: VirtualFurnitureAttributesAvailabilityStatusEnum.Public,
    })
  ).data.data.map(mapFurniture);
